<template>
  <ul class="flex flex-col gap-y-2">
    <slot />
  </ul>
</template>
